/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Model, { attr } from '@ember-data/model';

export default class OauthState extends Model {
  @attr('string') declare siteUrl: string;
  @attr('string') declare helpCenterId: string;
  @attr('boolean') declare newImporter: boolean;
}
